<template>
  <v-dialog
    :model-value="tutorialStore.open"
    max-width="720"
    scrollable
    :z-index="10100"
    @update:model-value="onToggle"
  >
    <v-card rounded="lg" :dir="chromeHebrew ? 'rtl' : 'ltr'">
      <v-card-title class="d-flex align-center">
        <span class="flex-grow-1">{{ title }}</span>
        <v-btn
          icon
          variant="text"
          size="small"
          :aria-label="chrome.close"
          data-cy="tutorial-dialog-close"
          @click="tutorialStore.close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-2">
        <TutorialVideoList
          v-if="tutorialStore.open"
          :videos="tutorialStore.videos"
          :hebrew="chromeHebrew"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTutorialStore } from "../store/pinia/tutorialStore";
import { usePracticeLocale } from "../composables/usePracticeLocale";
import { helpChrome } from "../i18n/practiceChrome";
import TutorialVideoList from "./TutorialVideoList.vue";

const tutorialStore = useTutorialStore();
const { chromeHebrew } = usePracticeLocale();
const chrome = computed(() => helpChrome(chromeHebrew.value));

const title = computed(() => {
  const list = tutorialStore.videos;
  if (list.length === 1) {
    return chromeHebrew.value ? list[0].titleHe : list[0].title;
  }
  return chrome.value.watch;
});

function onToggle(open: boolean) {
  if (!open) tutorialStore.close();
}
</script>
